import { forwardRef, Ref, type SVGProps } from 'react';

const SvgMoreIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 27 27"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.5 14.625a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M13.5 6.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M13.5 22.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMoreIcon);
export default ForwardRef;
